import { MdVolumeDown, MdVolumeOff, MdVolumeUp } from 'react-icons/md'

/** 現在の音量(0..1)に応じたスピーカーアイコン（消音 / 小 / 大）。 */
export const volumeIcon = (volume: number) => {
  if (volume <= 0) {
    return <MdVolumeOff size={20} aria-hidden="true" />
  }
  if (volume < 0.5) {
    return <MdVolumeDown size={20} aria-hidden="true" />
  }
  return <MdVolumeUp size={20} aria-hidden="true" />
}
